import React, { useState } from "react"
import DeleteModal from "../../../components/Common/DeleteModal"
import { usePagination } from "../../../hooks/usePagination"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../hooks/useResponse"
import TableAction from "../../../components/TableAction"
import EmptyData from "../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../api/permissions";
import { Button } from "reactstrap"
import { useHistory } from "react-router-dom"
import PaginationHandler from "../../../components/PaginationHandler"
import ResultHandler from "../../../components/ResultHandler"
import { deleteEducation, getAllEducations } from "../../../api/education"

const EducationTable = ({employeeId}) => {
    const { t } = useTranslation()
    const navigate = useHistory()
    const {
      response,
      loading,
      error,
      setPage,
      page,
      totalPages,
      setPayload,
    } = usePagination(getAllEducations, {employeeId})

    //// delete 
    const [show, setShow] = useState(false)
    const [deletingEducation, setDeletingEducation] = useState(null)
    
    const { setData } = useResponse(deleteEducation, () => {
      setShow(false)
      setDeletingEducation(null)
      setPayload({employeeId, ref: true})
    })

    function onCloseClick() {
      setShow(false)
    }
  
    function onDeleteClick() {
      setData({ type: "delete", data: deletingEducation})
    }

  return (
    <div className="table-rep-plugin">
      <div className="table-responsive">
        <Table className="table table-striped table-bordered">
          <Thead className="table-light table-nowrap">
            <Tr>
              <Th>Number</Th>
              <Th>Type</Th>
              <Th>Period</Th>
              <Th className="text-center">Acceptable</Th>
              <Th className="text-center" style={{ width: "20%" }}>{t("tables.Action")}</Th>
            </Tr>
          </Thead>

          {response.data && !loading && (
            <Tbody>
              {response.data.education.map((row,idx) => {
                return (
                  <Tr key={row.id}>
                    <Td>{idx+1}</Td>
                    <Td>{row.type}</Td>
                    <Td>{row.period}</Td>
                    <Td className={`text-center ${row.acceptable ? "text-success" : "text-danger"}`}>{row.acceptable ? "Yes" : "No"}</Td>
                    <Td className="text-center">
                      <TableAction
                        hasEdit={true}
                        hasDelete={true}
                        editPermission={PERMISSIONS.EMPLOYEE_EDIT}
                        deletePermission={PERMISSIONS.EMPLOYEE_DELETE}
                        type="education"
                        id={row.id}
                        setShow={setShow}
                        setDeleteIntitiy={setDeletingEducation}
                      />
                    </Td>
                  </Tr>
                )
              })}
            </Tbody>
          )}
        </Table>

        {!loading &&
          <EmptyData empty={response.data && response.data.education.length === 0} msg="No Education Found." />
        }

        {!loading && (
          <div className="d-flex" style={{justifyContent: "flex-end", marginTop: "20px"}}>
            <Button color="dark" onClick={() => navigate.push("/add-education/" + employeeId)}>Add</Button>
          </div>
        )}

        {response.data && !loading && (
          <PaginationHandler
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        )}

        <ResultHandler error={error} loading={loading} />

        <DeleteModal
          show={show}
          onDeleteClick={onDeleteClick}
          onCloseClick={onCloseClick}
        />

      </div>
    </div>
    //   <div className="bg-white p-4 border border-2" style={{marginBottom:'20px'}}>
    //     <h5 className="mb-3">EDUCATION</h5>
        
    //     {[1,2,3,4].map(item => <div className="d-flex align-items-center flex-wrap" key={item}>
    //         <div className="mb-1 me-5">
    //             <span className="me-3">{item}.</span>
    //         </div>
    //         <div className="mb-1 me-5">
    //             <span className="me-3">Type:</span>
    //             <span>elementary school	2008-2012</span>
    //         </div>
    //         <div className="mb-1 me-5">
    //             <span className="me-3">Acceptable:</span>
    //             <span className={`fw-bold ${true ? "text-success" : "text-danger"}`}>Yes</span>
    //         </div>
    //     </div> )}
        
    //     <div className="text-end mt-2">
    //         <Button color="dark" onClick={() => ""}>Add</Button>
    //     </div>
    // </div>
  )
}

export default EducationTable